import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { api } from './postMessage.js';

var _excluded = ["lng", "ns"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function handler(payload) {
  var lng = payload.lng,
    ns = payload.ns,
    rest = _objectWithoutProperties(payload, _excluded);
  api.i18n.getResourceBundle(lng, ns, function (resources) {
    api.confirmResourceBundle(_objectSpread({
      resources: resources,
      lng: lng,
      ns: ns
    }, rest));
  });
}
api.addHandler('requestResourceBundle', handler);
